import React from 'react';
import PropTypes from 'prop-types';

import EquippedGroup from 'components/Possessions/components/EquippedGroup/EquippedGroupContainer';

export default function EquippedComponent({ groups }: Props) {
  return (
    <ul className="equipped-groups">
      {groups.map(({ name }) => {
        // @ts-ignore
        return <EquippedGroup key={name} name={name} />;
      })}
    </ul>
  );
}

interface Props {
  groups: { name: string }[],
}

EquippedComponent.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
  })).isRequired,
};